<ng-container *ngIf="loading">
    <div class="flex justify-center items-center h-[500px]">
        <p-progressSpinner
            styleClass="w-20 h-20"
            strokeWidth="4"
            fill="transparent"
            animationDuration=".5s"
        ></p-progressSpinner>
    </div>
</ng-container>
<div class="tb:pl-5 tb:border-l border-gray-200" *ngIf="announcement">
    <div class="tb:hidden block mb-5">
        <sms-mobile-header>
            <div class="flex flex-col justify-center items-center">
                <span class="!text-heading !font-bold !font-satoshi leading-5">Announcements</span>
                <span class="text-gray-400 text-xs font-satoshi !font-normal">{{
                    announcement.announcement.title
                }}</span>
            </div>
        </sms-mobile-header>
    </div>
    <sms-announcement-detail
        class="block h-[calc(100%_-_55px)] tb:h-full"
        [announcement]="announcement"
        [isMobile]="true"
        [isPage]="true"
    ></sms-announcement-detail>
</div>
